import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { PermissionService } from 'src/app/core/services/permission/permission.service';
import { DashboardFacadeService } from 'src/app/modules/dashboard/services/dashboard-facade.service';
import { userAuthActionsFacadeService } from 'src/app/modules/login/services/user-auth-actions-facade.service';
import { SnackBarService } from 'src/app/shared';
import { ResolverService } from '../../core';
import { LoaderService } from '../../core/services/loader/loader.service';
// declare var FreshworksWidget;
@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit, OnDestroy {
  openStatus: boolean = true;
  userInitInfo;
  showTerms: boolean = true;
  isPhoneVerified: boolean = false;
  isWhatsAppVerified: boolean = false;
  isWhatsAppNumber: boolean = false;
  selectedPhoneNumber: string;
  verifyPhoneForm: FormGroup;
  isSubUser: boolean = false;
  validityCheckInfo!: any;
  isShopNewVersion: boolean = false;
  @ViewChild('verifyPhoneDialog') verifyPhoneDialog;
  @ViewChild('acceptInvitationDialog') acceptInvitationDialog;

  constructor(
    private router: Router, private resolvedService: ResolverService,
    private dashboardService: DashboardFacadeService,
    private dialog: MatDialog,
    private snackbarService: SnackBarService,
    private permissionService: PermissionService,
    private localStorageService: LocalStorageService,
    private userActionService: userAuthActionsFacadeService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    this.userInitInfo = this.resolvedService.userInitInfo;
    this.initForms();
    this.checkInvitationCode();
    this.setupValidityInfo();
    this.isSubUser = !(this.permissionService.isAdmin || this.permissionService.isOwner);
    this.resolvedService.updateInitInfo.subscribe(
      update => {
        if (update) {
          this.userInitInfo = this.resolvedService.userInitInfo;
          this.isPhoneVerified = this.userInitInfo.profile.phone_confirmed;
          this.isWhatsAppVerified = this.userInitInfo.profile.whatsapp_confirmed;
          this.isWhatsAppNumber = this.isPhoneVerified;
          this.selectedPhoneNumber = this.isWhatsAppNumber ? this.userInitInfo.profile.whatsapp : this.userInitInfo.profile.phone;
        }
      }
    )
    this.patchCrmValues();

    this.isPhoneVerified = this.userInitInfo.profile.phone_confirmed;
    this.isWhatsAppVerified = this.userInitInfo.profile.whatsapp_confirmed;
    this.isWhatsAppNumber = this.isPhoneVerified;
    this.selectedPhoneNumber = this.isWhatsAppNumber ? this.userInitInfo.profile.whatsapp : this.userInitInfo.profile.phone;
    this.checkIsNewShopVersion();
  }

  initForms() {
    this.verifyPhoneForm = new FormGroup({
      code: new FormControl('', Validators.required)
    })
  }

  isPrint() {
    return this.router.url.includes('print');
  }

  onToggleSidbar(event: boolean) {
    this.openStatus = event;
  }

  patchCrmValues() {
    // FreshworksWidget('destroy');
    // FreshworksWidget('boot');
    // if(this.userInitInfo.profile.sub_user) {
    //   FreshworksWidget('prefill', 'ticketForm', {
    //     name: this.userInitInfo.profile.sub_user.name,
    //     email: this.userInitInfo.profile.sub_user.email,
    //     custom_fields: {
    //       // cf_service: '',
    //     }
    //   });
    // } else {
    //   FreshworksWidget('prefill', 'ticketForm', {
    //     name: this.userInitInfo.profile.company,
    //     email: this.userInitInfo.profile.email,
    //     custom_fields: {
    //       // cf_service: '',
    //     }
    //   });
    // }
    // FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_service']);
    // FreshworksWidget('disable', 'ticketForm', ['name', 'email']);
  }

  ngOnDestroy() {
  }

  verifyPhone() {
    this.dashboardService.generatePhoneVerifyCode(this.isWhatsAppNumber).subscribe(
      () => {
        this.dialog.closeAll();
        this.openDialog(this.verifyPhoneDialog);
      }
    );
  }

  verifyPhoneCode() {
    this.dashboardService.verifyPhoneNumber(this.isWhatsAppNumber, this.verifyPhoneForm.value).subscribe(
      () => {
        this.dialog.closeAll();
        this.resolvedService.updateInfo();
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  checkInvitationCode() {
    if (this.localStorageService.invitationCode) {
      this.userActionService.checkInvitationCode({code: this.localStorageService.invitationCode}).subscribe(
        data => {
          // console.log(data)
          let ref = this.dialog.open(this.acceptInvitationDialog,
            {
              data,
              disableClose: true
            })
          ref.afterClosed().subscribe(
            d => {
              if (d) {
                this.userActionService.acceptMerchantInvite({ code: this.localStorageService.invitationCode }).subscribe(
                  () => {
                    this.localStorageService.invitationCode = undefined;
                   },
                  e => {
                    this.snackbarService.showSnack(e.detail);
                  }
                )
              } else {
                this.localStorageService.invitationCode = undefined;
              }
            }
          )
        },
        e => {
          this.snackbarService.showSnack(e.detail);
          this.localStorageService.invitationCode = undefined;
        }
      )
    }
  }

  openDialog(content) {
    this.dialog.open(content);
  }

  closeAllDialogs() {
    this.dialog.closeAll();
  }

  dismissVerify() {
    this.isWhatsAppVerified = true;
  }

  setupValidityInfo() {
    if(this.userInitInfo.validity_check.is_invalid) {
      const invalid_reason = this.userInitInfo.validity_check.invalid_reason.join(', '); 
      this.validityCheckInfo = {
        ...this.userInitInfo.validity_check,
        invalid_reason
      }
    }
  }

  checkIsNewShopVersion() {
    this.loaderService.getIsNewShopVersion().subscribe(
      status => {
        this.isShopNewVersion = status;
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    )
  }
}
